var React = require('react');

function ArrowBackWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.3337 4.83317H3.22033L6.94699 1.1065L6.00033 0.166504L0.666992 5.49984L6.00033 10.8332L6.94033 9.89317L3.22033 6.1665H11.3337V4.83317Z","fill":"white"}));
}

ArrowBackWhite.defaultProps = {"width":"12","height":"11","viewBox":"0 0 12 11","fill":"none"};

module.exports = ArrowBackWhite;

ArrowBackWhite.default = ArrowBackWhite;
